module.exports = __webpack_public_path__ + "static/img/logo.031b3497.png";